import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./mod_group_display_style.js";
//#region src/mod_group_display_style_helper.ts
var mod_group_display_style_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(displayStyle) {
	switch (displayStyle) {
		case "carousel": return "Carousel";
		case "default": return "Default";
		case "large-image": return "Large Image";
		case "quantity": return "Quantity";
		case "row-size-group": return "Row Size Group";
		case "size-group": return "Size Group";
		case "slider": return "Slider";
		default: throw new Error(`Unrecognized mod group display style: ${displayStyle}`);
	}
}
//#endregion
export { mod_group_display_style_helper_exports, name };

//# sourceMappingURL=mod_group_display_style_helper.js.map